// Hide all tooltips when the page loads
window.onload = function () {
  var tooltips = document.getElementsByClassName("tooltip-info");
  for (var i = 0; i < tooltips.length; i++) {
    tooltips[i].style.display = "none";
  }
};

function showTooltip(element) {
  var tooltip = element.getElementsByClassName("tooltip-info")[0];
  tooltip.style.display = "block";
  tooltip.style.position = "absolute";
  tooltip.style.zIndex = "1";
  tooltip.style.backgroundColor = "white";
  tooltip.style.border = "1px solid #eee";
  tooltip.style.width = "50%";
  tooltip.style.padding = "10px";
  tooltip.style.boxShadow = "1px solid #ddd";
  tooltip.style.zIndex = "9999999999999999";
}

function hideTooltip(element) {
  var tooltip = element.getElementsByClassName("tooltip-info")[0];
  tooltip.style.display = "none";
}
